import { useSignOut } from "@/hooks/useSignOut";

export function NoSiteAccess() {
  const handleLogout = useSignOut();

  return (
    <div className="flex min-h-dvh w-screen flex-col items-center justify-center gap-4 bg-[#0F1117] px-6 text-center text-white">
      <div className="text-xl font-semibold">접근 가능한 현장이 없습니다</div>
      <div className="max-w-sm text-sm leading-relaxed text-white/60">
        현재 계정에 부여된 현장 권한이 없습니다.
        <br />
        담당 관리자에게 현장 접근 권한을 요청해주세요.
      </div>
      <button
        type="button"
        onClick={handleLogout}
        className="mt-2 rounded-md border border-white/20 px-4 py-2 text-[0.8125rem] font-medium text-white/80 hover:bg-white/10"
      >
        로그아웃
      </button>
    </div>
  );
}
